export type Timeout = ReturnType<typeof setTimeout>

export function clearTimeout(timeout?: Timeout | null) {
  if (timeout) {
    window.clearTimeout(timeout)
  }
}
